const assocGroupStyles = (theme) => ({
  entityAssocGroup: {
    padding: '4px 0',
    position: 'relative',
    borderTop: '1px solid #e0e0e0',
  },
  entityAssocGroup_header: {
    padding: '12px 25px',
    position: 'relative',
    '& $quickAddToggle': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: '15px',
      margin: 'auto',
    },
  },
  entityAssocGroup_title: {
    fontFamily: 'MetricWebBold',
    fontSize: '1.2rem',
  },
  entityAssocGroup_expand: {
    marginLeft: '2px',
    transform: 'translateY(2px)',
    cursor: 'pointer',
  },
  entityAssocGroup_showMoreRow: {
    width: '100%',
    cursor: 'pointer',
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '0 25px 10px',
  },
  quickAddToggle: {
    cursor: 'pointer',
    height: '32px',
    width: '32px',
    fontSize: '20px',
    lineHeight: '20px',
    color: 'rgba(12,13,13,0.64)',
    transition: 'transform 0.2s cubic-bezier(0.55, 0, 0, 1)',
  },
  addOneButton: {
    cursor: 'pointer',
    border: 'none',
    userSelect: 'none',
    display: 'inline-block',
    outline: 0,
    textTransform: 'uppercase',
    '&$button_icon': {
      borderRadius: '50%',
      fontWeight: 400,
      padding: '6px',
      height: '36px',
      width: '36px',
      textAlign: 'center',
      transition: 'background-color .2s',
    },
  },
  button_icon: {},
  entitySummary: {
    padding: '8px 20px',
    position: 'relative',
    transition: 'background-color 0.3s cubic-bezier(0.55, 0, 0, 1)',
    '&$entitySummary_task': {
      '&.isComplete': {
        '& $entitySummary_title': {
          color: '#3b3e3f',
          textDecoration: 'line-through',
        },
      },
      '&:hover': {
        '& $docSummary_buttonContainer': {
          display: 'inline-block',
        },
      },
    },
  },

  docSummary_buttonContainer: {
    position: 'absolute',
    display: 'none',
    right: '4px',
    top: '-10px',
    '&:hover': {},
  },

  entitySummary_task: {},
  entitySummary_contact: {},
  entitySummary_icon: {
    color: '#fff',
    float: 'left',
    fontSize: '18px',
    lineHeight: '18px',
    height: '36px',
    width: '36px',
    margin: '5px 10px 5px 0',
  },
  entitySummary_buttonContainer: {
    display: 'none',
    margin: '-6px -10px -2px 0',
    position: 'absolute',
    right: '25px',
    transform: 'translate(12px, -10px) scale(0.75)',
    color: 'rgba(12,13,13,0.32)',
  },
  icon_darkenOnHover: {
    '&:hover': {
      color: 'rgba(12,13,13,0.64)',
    },
  },
  entitySummary_detail: {
    color: '#757575',
    float: 'right',
    maxWidth: '100px',
    lineHeight: '24px',
  },
  entitySummary_title: {
    color: '#0c0d0d',
    fontWeight: 500,
    lineHeight: '24px',
    minWidth: 0,
  },
  entitySummary_subtitle: {
    color: '#696e6f',
  },
  entitySummary_subtitleName: {
    maxWidth: '80%',
    verticalAlign: 'top',
    // the following are shared with entitySummary_subtitleGroup>span
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'default',
  },
  entitySummary_subtitleGroup: {
    fontSize: 0,
    lineHeight: 0,
    '&>span': {
      fontSize: '12px',
      lineHeight: '20px',
      maxWidth: '49%',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '&>span+span': {
      '&::before': {
        content: "'|'",
        padding: '0 6px',
      },
    },
  },
  entitySummaryCategory_title: {
    paddingLeft: '25px',
    fontStyle: 'italic',
  },
});

export default assocGroupStyles;
